import { render, staticRenderFns } from "./InterfaceMessage.vue?vue&type=template&id=61641d49&scoped=true"
import script from "./InterfaceMessage.vue?vue&type=script&lang=js"
export * from "./InterfaceMessage.vue?vue&type=script&lang=js"
import style0 from "./InterfaceMessage.vue?vue&type=style&index=0&id=61641d49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61641d49",
  null
  
)

export default component.exports